import React, { useState, useEffect, useCallback, useRef } from 'react';
import { ReactComponent as DemoIcon } from '../assets/icons/MenuIcon.svg'; 
import { db } from '../firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../assets/LoadingSpinner';
import ReactMarkdown from 'react-markdown';
import { CardPayment } from '@mercadopago/sdk-react'; 
import Factura from './Factura';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
const storage = getStorage();
const capitalizeFirstLetter = (string) => {
if (!string) return '';
return string.charAt(0).toUpperCase() + string.slice(1);
};
const formatDate = (fechasArray) => {
if (!fechasArray || fechasArray.length === 0) {
return 'Fecha no disponible';
}
const dateString = fechasArray[0]; 
const date = new Date(dateString);
const fullDateString = date.toLocaleDateString('es-ES', {
weekday: 'long',
year: 'numeric',
month: 'long',
day: 'numeric'
});
const parts = fullDateString.split(',');
if (parts.length > 0) {
const capitalizedDay = capitalizeFirstLetter(parts[0].trim());
return capitalizedDay + ', ' + parts.slice(1).join(',').trim();
}
return fullDateString;
};
const ReservaModal = ({
selectedDemo,
setShowModal,
isReserving,
reservaError,
reservaSuccess,
userName,
initialization,
onSubmit,
onError,
onReady,
isPaymentReady,
paymentStatus,
isLoadingPayment,
isPdfGenerating,
}) => {
const paymentApproved = paymentStatus === 'approved';
if (paymentApproved && isPdfGenerating) {
return (
<div className="modal-backdrop">
<div className="modal-content" style={{ textAlign: 'center', padding: '50px' }}>
<LoadingSpinner />
<p style={{ marginTop: '20px' }}>Finalizando compra y generando factura...</p>
</div>
</div>
);
}
return (
<div className="modal-backdrop">
<div className="modal-content" style={{height:'auto', width:'100%', padding: '1em 3em'}}>
<div className="modal-close" onClick={() => setShowModal(false)}>&times;</div>
{(isLoadingPayment && !paymentApproved) && (
<LoadingSpinner />
)}
{}
{!paymentApproved && !isLoadingPayment && (
<div style={{ marginTop: '20px' }}>
{}
{paymentStatus === 'rejected' && <p style={{color: 'red', textAlign: 'center'}}>⚠️ El pago fue rechazado. Verifica tus datos.</p>}
{paymentStatus === 'error' && <p style={{color: 'red', textAlign: 'center'}}>🚨 Hubo un error al procesar el pago. Intenta de nuevo.</p>}
{reservaError && <p style={{color: 'red', textAlign: 'center'}}>❌ {reservaError}</p>}
{}
<div style={{ display: (isPaymentReady && !isLoadingPayment) ? 'block' : 'none' }}>
<CardPayment
initialization={initialization}
onSubmit={onSubmit}
onReady={onReady}
onError={onError}
customization={{
visual: {
hideFormTitle: true,
theme: 'default',
hideEmailField: true,
style: {
customVariables: {
baseColor: "#2d1a3b",
baseColorFirstVariant: "#ffffff",
buttonTextColor: "#ffffff",
outlinePrimaryColor: "#ffffff",
errorColor: "#2d1a3b",
inputFocusedBoxShadow: "0 0 0 1px #2d1a3b",
inputErrorFocusedBoxShadow: "0 0 0 1px #2d1a3b",
inputBorderWidth: "1px",
inputFocusedBorderWidth: "1px",
fontWeightNormal: "400",
fontWeightSemiBold: "400",
borderRadiusMedium: "0",
textPrimaryColor: "#2d1a3b",
fontSizeExtraSmall: ".8em",
fontSizeSmall: ".8em",
fontSizeMedium: ".8em",
fontSizeLarge: ".8em",
fontSizeExtraLarge: ".8em",
inputBackgroundColor: "#a58d70",
formBackgroundColor: "#a58d70",
formInputsTextTransform: "none",
inputVerticalPadding: "5px",
inputHorizontalPadding: "5px",
formPadding: "10px",
textSecondaryColor:'#ffffff'
},
},
},
paymentMethods: {
maxInstallments: 1,
},
}}
/>
</div>
{}
{!isPaymentReady && <LoadingSpinner />}
</div>
)}
{}
{paymentApproved && reservaSuccess && (
<div className="success-message" style={{ textAlign: 'center', padding: '20px' }}>
<h2>¡Reserva y Pago Aprobados!</h2>
<p>Tu plaza para la demostración '{selectedDemo.titulo}' ha sido reservada con éxito. ¡Te esperamos!</p>
{}
</div>
)}
</div>
</div>
);
};
const formatearPrecio = (precioString) => {
const precioNumerico = parseInt(precioString, 10);
if (isNaN(precioNumerico)) {
return precioString;
}
return new Intl.NumberFormat('es-AR').format(precioNumerico);
};
function Demostraciones() {
const { user } = useAuth();
const idemKeyRef = useRef(null);
const [demostraciones, setDemostraciones] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);
const [showModal, setShowModal] = useState(false);
const [selectedDemo, setSelectedDemo] = useState(null);
const [isPaymentReady, setIsPaymentReady] = useState(false);
const [paymentStatus, setPaymentStatus] = useState(null);
const [isLoadingPayment, setIsLoadingPayment] = useState(false);
const [isReserving, setIsReserving] = useState(false);
const [reservaError, setReservaError] = useState(null);
const [reservaSuccess, setReservaSuccess] = useState(false);
const [isPdfGenerating, setIsPdfGenerating] = useState(false);
const [ventaId, setVentaId] = useState(null);
const [paymentType, setPaymentType] = useState('Tarjeta');
const facturaRef = useRef(null);
const fetchDemostraciones = useCallback(async () => {
try {
setLoading(true);
const demostracionesCol = collection(db, 'demostraciones');
const demostracionesSnapshot = await getDocs(demostracionesCol);
const allDemostraciones = demostracionesSnapshot.docs.map(doc => ({
id: doc.id,
...doc.data()
}));
const futureDemostraciones = allDemostraciones.filter(demo => {
if (demo.fechas && demo.fechas.length > 0) {
const dateTimestamp = new Date(demo.fechas[0]).getTime();
return !isNaN(dateTimestamp) && dateTimestamp > Date.now();
}
return false;
});
futureDemostraciones.sort((a, b) => {
const dateA = new Date(a.fechas[0]).getTime();
const dateB = new Date(b.fechas[0]).getTime();
return dateA - dateB;
});
let soonestAvailableDemo = null;
for (const demo of futureDemostraciones) {
const plazasTotales = parseInt(demo.cantidadPlazas, 10) || 0;
const invitadosCount = Array.isArray(demo.invitados) ? demo.invitados.length : 0;
const lugaresDisponibles = plazasTotales - invitadosCount;
if (lugaresDisponibles > 0) {
soonestAvailableDemo = demo;
break;
}
}
setDemostraciones(soonestAvailableDemo ? [soonestAvailableDemo] : []);
setError(null);
} catch (err) {
console.error("Error al cargar demostraciones:", err);
setError("No se pudo cargar la demostración disponible. Por favor, inténtalo de nuevo más tarde.");
} finally {
setLoading(false);
}
}, []);

useEffect(() => {
if (ventaId && facturaRef.current && selectedDemo && paymentType) {
handleGenerateAndUploadPDF(ventaId, paymentType)
.then(() => {
fetchDemostraciones();
})
.catch(error => {
console.error("Error en la secuencia de PDF:", error);
});
}
}, [ventaId, selectedDemo, paymentType, fetchDemostraciones]);

const handleGenerateAndUploadPDF = async (newVentaId, displayPaymentType) => {
if (!facturaRef.current) {
console.error("Referencia de la factura no disponible.");
return;
}
setIsPdfGenerating(true);
try {
const canvas = await html2canvas(facturaRef.current, {
scale: 2,
useCORS: true, 
logging: true,
});
const imgData = canvas.toDataURL('image/jpeg', 1.0); 
const pdf = new jsPDF({
orientation: 'p',
unit: 'mm',
format: 'a4'
});
const imgWidth = 210; 
const pageHeight = 297; 
const imgHeight = canvas.height * imgWidth / canvas.width;
let heightLeft = imgHeight;
let position = 0;
pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
heightLeft -= pageHeight;
while (heightLeft >= 0) {
position = heightLeft - imgHeight;
pdf.addPage();
pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
heightLeft -= pageHeight;
}
const pdfBlob = pdf.output('blob');
const fileName = `${newVentaId}.pdf`;
const storageReference = storageRef(storage, `facturas/${fileName}`);
await uploadBytes(storageReference, pdfBlob);
const downloadURL = await getDownloadURL(storageReference);
console.log('Factura subida con éxito. ID:', newVentaId, 'URL:', downloadURL);
} catch (error) {
console.error('Error al generar o subir el PDF:', error);
} finally {
setIsPdfGenerating(false);
}
};

useEffect(() => {
fetchDemostraciones();
}, [fetchDemostraciones]);

const handleOpenModal = (demostracion) => {
idemKeyRef.current = crypto.randomUUID();
setShowModal(true)
setSelectedDemo(demostracion);
setIsPaymentReady(false);
setPaymentStatus(null);
setIsLoadingPayment(false);
setReservaError(null);
setReservaSuccess(false);
};
const onSubmit = async (formData) => {
setIsLoadingPayment(true);
setPaymentStatus(null);
if (!selectedDemo || !user) {
setReservaError("Error: No se ha seleccionado una demostración o el usuario no está autenticado.");
setIsLoadingPayment(false);
return Promise.reject(new Error("Datos faltantes."));
}
const price = parseInt(selectedDemo.precio, 10);
const dataToSend = {
...formData,
transaction_amount: price,
user_uid: user.uid,
demoId: selectedDemo.id,
idempotency_key: idemKeyRef.current,
};
return new Promise((resolve, reject) => {
user.getIdToken().then((idToken) =>
fetch('https://backend-288175208699.europe-west1.run.app/api/reservar-y-pagar-demostracion', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
'Authorization': `Bearer ${idToken}`,
},
body: JSON.stringify(dataToSend),
}))
.then((response) => {
if (!response.ok) {
throw new Error('Network response was not ok or payment failed on server.');
}
return response.json();
})
.then(async (response) => {
if (response.status === 'approved') {
setPaymentStatus('approved');
setReservaSuccess(true);
const newVentaId = response.venta_id || `DEMO-${Date.now()}`;
const mpPaymentType = response.payment_type;
let displayPaymentType = 'Tarjeta'; 
if (mpPaymentType === 'credit_card') {
displayPaymentType = 'Tarjeta de Crédito';
} else if (mpPaymentType === 'debit_card') {
displayPaymentType = 'Tarjeta de Débito';
}
setVentaId(newVentaId);
setPaymentType(displayPaymentType);
} else {
setPaymentStatus('rejected');
setReservaError(response.message || 'El pago fue rechazado o no se completó.');
}
setIsLoadingPayment(false);
resolve();
})
.catch((error) => {
console.error('Error al procesar el pago/reserva:', error);
setIsLoadingPayment(false);
setPaymentStatus('error');
setReservaError(error.message || 'Error en la comunicación con el servidor de pago.');
reject(error);
});
});
};
const onError = async (error) => {
console.log('Error de Brick:', error);
setReservaError("Error interno en el formulario de pago. Intenta de nuevo.");
};
const onReady = async () => {
setIsPaymentReady(true);
};
if (loading) {
return <LoadingSpinner/>;
}
if (error) {
return <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>Error: {error}</div>;
}
if (demostraciones.length === 0) {
return <div style={{ textAlign: 'center', padding: '20px' }}>No hay demostraciones disponibles en este momento.</div>;
}

return (
<div className="historia-container" >
<div style={{position:'absolute',zIndex:'-999999',left:'-9999px'}}>
<div style={{
position: 'relative',
width: '210mm',
height: '590mm',
overflowY: 'auto'
}}>
{(selectedDemo && ventaId) && (
<Factura
ref={facturaRef}
datosCliente={user?.profileData || {}}
productosVendidos={[{ 
idProducto: selectedDemo.id,
nombreProducto: selectedDemo.titulo,
cantidad: 1,
precioUnidad: parseInt(selectedDemo.precio, 10),
tipoUnidad: 'u',
}]}
tipoFactura="B"
totalNeto={parseInt(selectedDemo.precio, 10) / 1.21}
iva21={parseInt(selectedDemo.precio, 10) * 0.21 / 1.21}
iva10_5={0} 
totalFinal={parseInt(selectedDemo.precio, 10)}
numeroComprobante={ventaId}
modalidadPago={paymentType}
datosCheque={null}
/>
)}
</div>
</div>
<div className="contenido-scrollable">
<div className="titulo-principal">
<hr className="linea-horizontal" />
<h1>más allá de la copa</h1>
<hr className="linea-horizontal" />
</div>
<p className="contenido-centrado">
El vino es un universo de sensaciones que se expande con el conocimiento. El verdadero disfrute no termina al descorchar una botella; en realidad, es allí donde apenas comienza.
<br className='spacer-10px'></br>Esta sección es un espacio curado por expertos, diseñado para el aficionado y el entusiasta que busca ir un paso más allá y comprender el "por qué" detrás de cada aroma y sabor.
<br className='spacer-10px'></br>Aquí, la alta gastronomía, la ciencia del maridaje y los fundamentos de la enología se encuentran. A través de exhibiciones de cocina, clases magistrales de armonización y charlas técnicas sobre viticultura, buscamos compartir el arte y la disciplina que viven detrás de cada etiqueta.
<br className='spacer-10px'></br>Estos encuentros son una oportunidad única para aprender, compartir experiencias y profundizar su conexión con la cultura del vino, de la mano de los protagonistas de nuestra finca y de maestros invitados.
<br className='spacer-10px'></br>Explore nuestras próximas demostraciones y reserve su lugar en esta experiencia de aprendizaje.</p>
<div className="titulo-principal" style={{margin:'30px 0'}}>
<hr style={{borderColor:'#ab9374'}} className="linea-horizontal" />
<h1 style={{color:'#ab9374'}}>PRÓXIMA DEMOSTRACIÓN</h1>
<hr style={{borderColor:'#ab9374'}} className="linea-horizontal" />
</div>
<ul className="degustaciones-list">
{demostraciones.map((demostracion) => {
const plazasTotales = parseInt(demostracion.cantidadPlazas, 10) || 1;
const invitadosCount = Array.isArray(demostracion.invitados) ? demostracion.invitados.length : 0;
const lugaresDisponibles = plazasTotales - invitadosCount;
let esCompleto = lugaresDisponibles <= 0;
const reservasUsuario = user?.profileData?.reservas || [];
const yaReservado = reservasUsuario.some(reserva => reserva.demoId === demostracion.id);
const deshabilitarBoton = esCompleto || !user || yaReservado;
const textoBoton = yaReservado ? 'Reservado' : (esCompleto ? 'Completo' : 'Reservar una plaza');
let disponibilidadTexto = esCompleto ? 'Completo' : `Quedan ${lugaresDisponibles} plazas`;

let botonClasses = 'degustacion-btn-reserva';
if (deshabilitarBoton) {
botonClasses += ' degustacion-btn-reserva--disabled';
}
if (yaReservado) {
botonClasses += ' degustacion-btn-reserva--reserved';
}
return (
<li
key={demostracion.id}
className="degustacion-item"
style={{
display: 'flex',
flexDirection: 'column',
alignItems: 'flex-start',
height: 'auto'
}}
>
{}
<div className="evento-item-fechas" style={{color: '#1a1a1a' }}>
<DemoIcon style={{ overflow: 'visible', width: '20px', fill:'#a58d70',marginRight:'5px'}} />
<span style={{fontSize:'15px', fontWeight: 'bold',margin: '0' }}>{formatDate(demostracion.fechas)}</span>
<span style={{fontSize:'15px', margin: '0' }}>-</span>
<span style={{fontSize:'15px', fontWeight: 'bold',margin: '0' }}>{demostracion.hora || 'S/H'}</span>
</div>
{}
<h3 style={{ margin: '0', fontSize: '22px', color: '#2d193b', width: '100%', }}>{demostracion.titulo}</h3>
<div className='demo-description-paragraph'>
<ReactMarkdown>
{demostracion.descripcion || 'Una sesión detallada para explorar las funcionalidades clave de nuestro producto.'}
</ReactMarkdown>
</div>
<div className="precio-container" style={{ width:'100%', transform: 'translateY(-15px)'}}>
<h2 >VALOR DEL EVENTO</h2>
<div className="precio-detalles" style={{width:'100%', padding:'20px 20px 30px'}}>
<p className="precio-monto" style={{color: 'black', fontWeight:'bold'}}>
— AR $ {formatearPrecio(demostracion.precio)} por invitado —
</p>
<h3 style={{margin: '0 0 10px', fontSize: '12px', color: '#8f1941', textTransform: 'uppercase'}}>
<span style={{fontWeight: 'bold', fontSize: '14px'}}>
{disponibilidadTexto}
</span>
</h3>
<button
onClick={() => handleOpenModal(demostracion)}
disabled={deshabilitarBoton}
className={botonClasses}
style={{
marginTop: '15px',
width: 'fit-content',
padding:'7px 25px',
fontSize: '16px',
alignSelf: 'center'
}}
>
{textoBoton}
</button>
</div>
</div>
</li>
)
})}
</ul>
{showModal && selectedDemo && (
<ReservaModal
selectedDemo={selectedDemo}
isReserving={isReserving}
reservaError={reservaError}
reservaSuccess={reservaSuccess}
setShowModal={setShowModal}
userName={user?.profileData?.nombre}
initialization={{ amount: parseInt(selectedDemo.precio, 10) }}
onSubmit={onSubmit}
onError={onError}
onReady={onReady}
isPaymentReady={isPaymentReady}paymentStatus={paymentStatus}
isLoadingPayment={isLoadingPayment}
isPdfGenerating={isPdfGenerating}
/>
)}
</div>
</div>
);
}
export default Demostraciones;